/**
 * Cart Drawer — Product Recommendations
 * Extracted from inline <script> in layout/theme.liquid for parser/cache efficiency.
 *
 * Configuration is read from window.cartRecosData, which is set inline in
 * theme.liquid before this script loads:
 *   window.cartRecosData = { moneyFormat, shopCurrency, quickViewText }
 */
(function () {
  var cfg = window.cartRecosData || {};
  var moneyFormat = cfg.moneyFormat || '${{amount}}';
  var shopCurrency = cfg.shopCurrency || 'EUR';
  var quickViewText = cfg.quickViewText || 'Quick view';

  // The recos snippet is rendered twice in the cart drawer (once for desktop
  // position, once for mobile). Both DOM roots exist; CSS only shows one
  // per viewport. We populate ALL of them so a viewport resize "just works".
  var RECO_ROOT_SELECTOR = '.cart-recos';
  var refreshTimer = null;
  var refreshing = false;
  // Cache key (anchor productId + recommended product IDs). When the next
  // refresh produces the same key we skip the rebuild entirely — this avoids
  // destroying + recreating Swiper instances on unrelated drawer DOM mutations
  // (e.g. opening a Quick-View modal) which would reset the user's scroll
  // position back to the start.
  var lastBuildKey = '';

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    try { return Shopify.formatMoney(cents, moneyFormat); }
    catch (e) {
      var v = (parseInt(cents, 10) || 0) / 100;
      return v.toLocaleString(undefined, { style: 'currency', currency: shopCurrency });
    }
  }

  function getDrawerRoot() {
    return document.getElementById('CartDrawer') || document.querySelector('#CartDrawer');
  }
  function getRecoRoots() {
    return Array.prototype.slice.call(document.querySelectorAll(RECO_ROOT_SELECTOR));
  }
  function showHide(root, show) {
    if (!root) return;
    if (show) root.removeAttribute('hidden');
    else root.setAttribute('hidden', '');
  }
  function showLoading(on) {
    getRecoRoots().forEach(function (root) {
      var lo = root.querySelector('.loading-overlay');
      if (lo) lo.classList.toggle('hidden', !on);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function firstProductIdFromDOM() {
    var dr = getDrawerRoot(); if (!dr) return null;
    var firstItem = dr.querySelector('.cart-item[product-id]');
    return firstItem ? firstItem.getAttribute('product-id') : null;
  }

  async function fetchRecsFor(productId) {
    if (!productId) return [];
    try {
      var intents = ['complementary', 'related'];
      var products = [];
      for (var i = 0; i < intents.length; i++) {
        var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
                  '&limit=12&intent=' + intents[i];
        var res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) continue;
        var data = await res.json();
        products = (data.products || []);
        if (products.length) break;
      }
      var cart = await fetchCart();
      var inCart = new Set((cart && cart.items || []).map(function (i) { return i.handle; }));
      return products.filter(function (p) { return !inCart.has(p.handle); });
    } catch (e) {
      return [];
    }
  }

  function escAttr(s) { return (s || '').replace(/"/g, '&quot;'); }

  function slideHTML(p) {
    var url = p.url || ('/products/' + p.handle);
    var img = (p.images && p.images[0]) ? p.images[0] : (p.featured_image || null);
    var imgSrc = img ? (typeof img === 'string' ? img : img.src) : '//cdn.shopify.com/s/images/admin/no-image-large.gif';
    var price = (p.price_min != null ? p.price_min
                : (p.price != null ? p.price
                : (p.variants && p.variants[0] && p.variants[0].price))) || 0;
    var compare = (p.compare_at_price_min != null ? p.compare_at_price_min
                  : (p.compare_at_price != null ? p.compare_at_price
                  : (p.variants && p.variants[0] && p.variants[0].compare_at_price))) || 0;
    var pid = p.id;
    var title = p.title || '';
    var titleAttr = escAttr(title);
    var isOnSale = compare > price;

    return '\n      <div class="swiper-slide">\n' +
      '        <div class="cart-recos__slide">\n' +
      '          <a class="cart-recos__img" href="' + url + '" aria-label="' + titleAttr + '">\n' +
      '            <img loading="lazy" src="' + imgSrc + '" alt="' + titleAttr + '">\n' +
      '          </a>\n' +
      '          <div class="cart-recos__main">\n' +
      '            <a class="cart-recos__product-title" href="' + url + '">' + title + '</a>\n' +
      '            <div class="cart-recos__price">\n' +
      (isOnSale ? '              <s class="cart-recos__compare">' + formatMoney(compare) + '</s>\n' : '') +
      '              <span class="cart-recos__now' + (isOnSale ? ' cart-recos__now--sale' : '') + '">' + formatMoney(price) + '</span>\n' +
      '            </div>\n' +
      '            <div class="cart-recos__qv">\n' +
      '              <modal-opener-quick-view data-modal="#QuickAdd-' + pid + '">\n' +
      '                <button type="button" class="quick-product__btn"' +
      ' data-product-url="' + url + '" data-product-id="' + pid + '"' +
      ' data-modal-id="QuickAdd-' + pid + '" data-modal-class="quick-add-modal">' +
      quickViewText + '</button>\n' +
      '              </modal-opener-quick-view>\n' +
      '            </div>\n' +
      '          </div>\n' +
      '        </div>\n' +
      '      </div>';
  }

  function buildSwiperFor(root) {
    var el = root.querySelector('.cart-recos__swiper'); if (!el || !window.Swiper) return;
    if (el._swiper) { try { el._swiper.destroy(true, true); } catch (e) { } el._swiper = null; }
    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var spv = (slideCount <= 2) ? slideCount : 'auto';
    el._swiper = new Swiper(el, {
      slidesPerView: spv,
      spaceBetween: 10,
      freeMode: { enabled: true, sticky: false, momentumBounce: false, momentumRatio: 0.6 },
      grabCursor: true,
      mousewheel: { forceToAxis: true, sensitivity: 0.6 },
      scrollbar: {
        el: root.querySelector('.cart-recos__scrollbar'),
        draggable: true,
        snapOnRelease: false,
        hide: false
      },
      watchOverflow: true,
      // observer auto-updates Swiper on container size changes (good).
      // observeSlideChildren caused scroll-position resets when the Quick-View
      // modal-opener mutated DOM inside a slide — disabled.
      // observeParents disabled for the same reason; we rebuild manually when
      // we actually need to.
      observer: true,
      observeParents: false,
      observeSlideChildren: false
    });
  }

  async function refreshRecos() {
    if (refreshing) return;
    refreshing = true;
    showLoading(true);

    var roots = getRecoRoots();
    if (!roots.length) { refreshing = false; showLoading(false); return; }

    var pid = firstProductIdFromDOM();
    if (!pid) {
      var cart = await fetchCart();
      pid = (cart && cart.items && cart.items[0] && cart.items[0].product_id) || null;
    }
    if (!pid) {
      roots.forEach(function (r) { showHide(r, false); });
      showLoading(false);
      refreshing = false;
      return;
    }

    var recs = await fetchRecsFor(pid);

    if (!recs.length) {
      if (lastBuildKey !== '') {
        roots.forEach(function (r) {
          var w = r.querySelector('.swiper-wrapper'); if (w) w.innerHTML = '';
          showHide(r, false);
        });
        lastBuildKey = '';
      }
      showLoading(false);
      refreshing = false;
      return;
    }

    // Skip rebuild if the recommendation set is identical to what's already
    // rendered — preserves Swiper scroll position when unrelated events
    // (Quick-View modal open, etc.) fire the observers.
    var newKey = pid + '|' + recs.map(function (p) { return p.id; }).join(',');
    if (newKey === lastBuildKey) {
      showLoading(false);
      refreshing = false;
      return;
    }
    lastBuildKey = newKey;

    var html = recs.map(slideHTML).join('');
    roots.forEach(function (r) {
      var w = r.querySelector('.swiper-wrapper'); if (w) w.innerHTML = html;
      showHide(r, true);
      buildSwiperFor(r);
    });

    showLoading(false);
    refreshing = false;
  }

  function scheduleRefresh(delay) {
    if (delay == null) delay = 80;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshRecos, delay);
  }

  /* ---------- React to drawer rerenders & cart mutations ---------- */
  function hookCartDrawer() {
    var Ctor = customElements.get('cart-drawer');
    if (!Ctor) return;
    var proto = Ctor.prototype;
    if (proto.__recosWrapped) return;
    var _render = proto.renderContents;
    proto.renderContents = function (payload) {
      var r = _render.call(this, payload);
      scheduleRefresh(10);
      return r;
    };
    proto.__recosWrapped = true;
  }

  function observeDrawer() {
    var target = getDrawerRoot();
    if (!target || target.__recoObserved) return;
    var mo = new MutationObserver(function (muts) {
      var hit = muts.some(function (m) {
        return Array.from(m.addedNodes).concat(Array.from(m.removedNodes))
          .some(function (n) {
            return n.nodeType === 1 && (
              (n.matches && n.matches('.cart-item')) ||
              (n.querySelector && n.querySelector('.cart-item'))
            );
          });
      });
      if (hit) scheduleRefresh(30);
    });
    mo.observe(target, { subtree: true, childList: true });
    target.__recoObserved = true;
  }

  /* Catch AJAX cart changes (fetch + XHR) */
  function hookNetwork() {
    if (!window.__recoFetchWrap && window.fetch) {
      var _f = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var mut = /\/cart\/(add|change|update)\.js(\?|$)/.test(url);
        return _f.apply(this, arguments).then(function (res) { if (mut) scheduleRefresh(120); return res; });
      };
      window.__recoFetchWrap = true;
    }
    if (!window.__recoXHRWrap && window.XMLHttpRequest) {
      var _open = XMLHttpRequest.prototype.open;
      var _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__cartMut = /\/cart\/(add|change|update)\.js(\?|$)/.test(String(url));
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__cartMut) { this.addEventListener('loadend', function () { scheduleRefresh(120); }, { once: true }); }
        return _send.apply(this, arguments);
      };
      window.__recoXHRWrap = true;
    }
  }

  function boot() {
    hookCartDrawer();
    observeDrawer();
    hookNetwork();
    scheduleRefresh(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  /* If the <cart-drawer> custom element is upgraded or injected after boot,
     wait for it ONCE and then stop observing. Listening to every DOM
     mutation on documentElement forever is too expensive. */
  if (!customElements.get('cart-drawer') || !getDrawerRoot()) {
    var late = new MutationObserver(function () {
      hookCartDrawer();
      observeDrawer();
      if (customElements.get('cart-drawer') && getDrawerRoot()) {
        late.disconnect();
      }
    });
    late.observe(document.documentElement, { subtree: true, childList: true });
  }
})();
